import { Toast,PullRefresh  } from 'vant';

// var timer;
var that;
export default {

  data() {
    return {
      iconPointer:require ("@/assets/cba/pointer.png"),
      iconTimeStart:require ("@/assets/cba/list_time_start.png"),
      iconTimeEnd:require ("@/assets/cba/list_time_end.png"),
      cdaLists: [
      
      ],
      loading: false,
      subcdaListsSize: 3,
    };
  },

  created() {
    that = this;
    this.getSignUpActivityList();
    // setInterval(() => { //每5秒刷新一次图表
    //     this.getSignUpActivityList();
    // }, 5000);
  },

  mounted() {
    // timer = setInterval(() => {
    //   //每5秒刷新一次图表
    //   this.getSignUpActivityList();
    // }, 5000);
  },
  unmounted() {
    // clearInterval(timer);
  },
  methods: {
    getSignUpActivityList() {
      let flag = this.$route.query.flag;
      console.log('flag:', flag);
      this.$api.getSignUpActivityList({
        params: {
          memberId: this.$route.query.memberId + "",
        },
        success: function (res) {
          console.log("resres", res.data);
          if(flag == 1){
              that.cdaLists = res.data.filter(item => item.projectName.indexOf('篮球') !== -1)
          }else if(flag == 2){
              that.cdaLists = res.data.filter(item => item.projectName.indexOf('门票') !== -1)
          }else{
            that.cdaLists = res.data;
          }
          console.log("cdaLists", that.cdaLists);
        },
      });
    },

    jumpInfo(item) {
      // if(item.signUpStatus ==0){
        this.$router.push({
          path: "/cbaTicketDetail",
          query: {
            activityId: item.activityId,
            memberId: this.$route.query.memberId,
          },
        });
      // }else if(item.signUpStatus ==1){
      //   Toast('报名尚未开始！');
      // }else{

      //   Toast('活动已结束！');
      // }

    },

    goUrl() {
      this.$router.push({
        path: "/cbaTicketRecords",
        query: {
          memberId: this.$route.query.memberId,
          flag: this.$route.query.flag,
        },
      });
    },
    onRefresh(){
      setTimeout(() => {
        Toast('刷新成功');
        that.loading = false;
        this.getSignUpActivityList();
      }, 1000);
    }
  },
};
